module.exports = __webpack_public_path__ + "img/AT0000002634945.5a4259b4.png";